module.exports = __webpack_public_path__ + "img/burger-menu-1.03d54dbd.jpg";